import { render, staticRenderFns } from "./host-common-ad.vue?vue&type=template&id=0516f5a6&scoped=true&"
import script from "./host-common-ad.vue?vue&type=script&lang=js&"
export * from "./host-common-ad.vue?vue&type=script&lang=js&"
import style0 from "./host-common-ad.vue?vue&type=style&index=0&id=0516f5a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0516f5a6",
  null
  
)

export default component.exports